import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArchive = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={35} height={34} fill='none' {...props}>
    <rect width={34} height={34} x={0.25} fill='#26C6DA' rx={8} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M22.875 15.665v6.585c0 1.5-.375 2.25-2.25 2.25h-6.75c-1.875 0-2.25-.75-2.25-2.25v-6.585M12 9.5h10.5q2.25 0 2.25 2.25v1.5q0 2.25-2.25 2.25H12q-2.25 0-2.25-2.25v-1.5Q9.75 9.5 12 9.5M15.885 18.5h2.73'
    />
  </svg>
);
export default SvgArchive;
